import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ProposalAdvisorConversationAvatar } from './ProposalAdvisorConversationAvatar'
import { AdvisorConversationMessage } from './types'
import { useDateFormatter } from '../../../../lib/hooks'
import { cn } from '../../../../shadcn/utils'
import { Icon } from '../../../atoms'

type ProposalAdvisorConversationHintProps = Readonly<{
  lastMessage?: AdvisorConversationMessage & { content: string }
  unreadMessages?: number
  onClick?: () => void
}>

export function ProposalAdvisorConversationHint({
  lastMessage,
  onClick,
  unreadMessages,
}: ProposalAdvisorConversationHintProps) {
  const formatter = useDateFormatter()

  formatter.updateTemplate('advisorWordLastMessage', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })

  const formatSentAt = (date: Date) =>
    formatter.format({
      date,
      formatString: 'advisorWordLastMessage',
    })

  return (
    <button
      className={cn(
        'flex w-full flex-row items-center gap-2 rounded-[4px] bg-white px-4 py-3',
        'hover:bg-grey-400',
        lastMessage && 'border-0 border-b border-solid border-grey-400',
      )}
      onClick={() => onClick?.()}
    >
      {lastMessage ? (
        <>
          <ProposalAdvisorConversationAvatar
            firstname={lastMessage.author.firstname}
            profilePicture={lastMessage.author.profilePicture}
          />
          <div className='flex flex-col justify-stretch overflow-hidden text-left'>
            <div className='font-bold'>
              {lastMessage.author.firstname} {lastMessage.author.lastname}
            </div>
            <div className='min-w-0 truncate whitespace-nowrap'>
              {lastMessage.content}
            </div>
          </div>
          <div className='ml-auto flex h-full flex-col items-end gap-2'>
            <time
              dateTime={formatSentAt(lastMessage.sentAt)}
              className='whitespace-nowrap text-sm text-grey-700'
            >
              {formatSentAt(lastMessage.sentAt)}
            </time>
            {unreadMessages !== undefined && unreadMessages > 0 && (
              <span className='flex size-4 items-center justify-center rounded-full bg-red-500 text-[10px] text-white'>
                {unreadMessages}
              </span>
            )}
          </div>
        </>
      ) : (
        <>
          <Icon name='chat' size={10} />
          <FormattedMessage
            id='ui.ProposalAdvisorConversationHint.addAComment'
            defaultMessage='Ajouter un commentaire'
          />
        </>
      )}
    </button>
  )
}

export default ProposalAdvisorConversationHint
